import axios from 'axios'
import moment from 'moment'
import {request} from '../middleware/auth-intercepter'
import {API_TYPE} from '../utils/Utils'
import CustomLogger from '../utils/CustomLogger'

let APIURL = process.env.REACT_APP_SERVER_URL + '/api/v1'

export const getAllUser = async (data) => {
  try {
    const apiUrl = `/web/users/get/all`

    delete data.total_page

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response.data
  } catch (error) {
    CustomLogger.error('Error in Get All User', error.message)
    return error.message
  }
}

export const getAllStore = async (data) => {
  try {
    const apiUrl = `/web/stores/get/all`

    delete data.total_page

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response.data
  } catch (error) {
    CustomLogger.error('Error in Get All Stores', error.message)
    return error.message
  }
}

export const getAllUserForChatModerator = async (query) => {
  try {
    const loginUser = JSON.parse(localStorage.getItem('kt-auth-react-v') || '')
    let isAdmin = true

    if (loginUser.roleName === 'Admin Chat Moderator' || loginUser.roleName === 'Chat Moderator') {
      isAdmin = false
    }

    let apiUrl = `/web/users/all-user-by-chat-moderator?moderatorId=1&${query}&isAdmin=${isAdmin}`

    if (query.includes('moderatorId=')) {
      apiUrl = `/web/users/all-user-by-chat-moderator?${query}&isAdmin=${isAdmin}`
    }

    if (loginUser.roleName === 'Chat Moderator') {
      apiUrl = `/web/users/all-user-by-chat-moderator?moderatorId=${loginUser.adminUserId}&${query}&isAdmin=${isAdmin}`
    }

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const deleteUserAccount = async (userIDs) => {
  try {
    let formdata = new FormData()
    formdata = {
      userIds: userIDs,
    }

    const apiUrl = `/web/users/delete`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    return error.message
  }
}

export const deleteStoreAccount = async (userIDs) => {
  try {
    let formdata = new FormData()
    formdata = {
      userIds: userIDs,
    }

    const apiUrl = `/web/stores/delete`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    return error.message
  }
}

export const loginWithEmailAndPassword = async (email, password) => {
  const apiUrl = `/auth/admin/login`

  let data = {
    email: email,
    password: password,
  }

  let response = await request(apiUrl, API_TYPE.POST, data, false, false)

  if (response.success) {
    localStorage.setItem('accessToken', response.data.token)
    sessionStorage.setItem('accessToken', response.data.token)
    localStorage.setItem('loginUserId', response.data._id)
  }

  return response
}

export const getCitiesBYSearch = async (searchText) => {
  try {
    const apiUrl = `/masters/cities?search=${searchText}&citySearch=${0}`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response.data
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getStateBYSearch = async (searchText) => {
  try {
    const apiUrl = `/masters/states?search=${searchText}`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getCountriesList = async () => {
  try {
    const apiUrl = `/masters/countries`

    let response = await request(apiUrl, API_TYPE.GET, {}, true)

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getStateList = async (countryID) => {
  try {
    const apiUrl = `/masters/countries/${countryID}/states`

    let response = await request(apiUrl, API_TYPE.GET, {}, true)

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getCityList = async (stateID) => {
  try {
    const apiUrl = `/masters/countries/states/${stateID}/cities`

    let response = await request(apiUrl, API_TYPE.GET, {}, true)

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getUserProfileDetailsUsingUserID = async (userID, fromCreateStore, fromId) => {
  try {
    const apiUrl = `/web/users/profile`

    let data = {user_id: userID, fromCreateStore: fromCreateStore, fromId}

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getStoreProfileDetailsUsingUserID = async (storeId) => {
  try {
    const apiUrl = `/web/stores/profile`

    let data = {store_id: storeId}

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const deleteOfferByOfferId = async (offerId) => {
  try {
    const apiUrl = `/web/offers/delete`

    let data = {offerId: offerId}

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateExpireOfferStatus = async (offerId) => {
  try {
    const apiUrl = `/web/offer/update/expire`

    let data = {offer_id: offerId}

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateOfferStatus = async (action, rejectReason, offerId, storeId) => {
  try {
    const apiUrl = `/web/offer/update/status`

    let data = {action: action, offer_id: offerId, reject_reason: rejectReason, store_id: storeId}

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getCommentsByOfferId = async (offerId, page, pageSize) => {
  try {
    const apiUrl = `/web/offers/comments/all`

    let data = {offerId: offerId, page, pageSize}

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getLikesByOfferId = async (offerId, page, pageSize) => {
  try {
    const apiUrl = `/web/offers/likes/all`

    let data = {offerId: offerId, page, pageSize}

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getSharesByOfferId = async (offerId, page, pageSize) => {
  try {
    const apiUrl = `/web/offers/shares/all`

    let data = {offerId: offerId, page, pageSize}

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getLocationsByOfferId = async (offerId, page, pageSize) => {
  try {
    const apiUrl = `/web/offers/locations/all`

    let data = {offerId: offerId, page, pageSize}

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getCallsByOfferId = async (offerId, page, pageSize) => {
  try {
    const apiUrl = `/web/offers/calls/all`

    let data = {offerId: offerId, page, pageSize}

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getViewsByOfferId = async (offerId, page, pageSize) => {
  try {
    const apiUrl = `/web/offers/views/all`

    let data = {offerId: offerId, page, pageSize}

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getUserActivityWithPagination = async (page, pageSize, type, userId, filter) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
      user_id: userId,
      type: type,
    }

    if (filter.type === 'lastHour') {
      data['lastHour'] = filter.type
    }

    if (filter.type === 'lastDay') {
      data['lastDay'] = filter.type
    }

    if (filter.type === 'lastWeek') {
      data['lastWeek'] = filter.type
    }

    if (filter.type === 'custom') {
      data['startDate'] = filter.startDate
      data['endDate'] = filter.endDate
    }

    const apiUrl = `/web/users/activity`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getStoreActivityWithPagination = async (
  page,
  pageSize,
  type,
  userId,
  storeId,
  filter
) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
      user_id: userId,
      store_id: storeId,
      type: type,
    }

    if (filter.type === 'lastHour') {
      data['lastHour'] = filter.type
    }

    if (filter.type === 'lastDay') {
      data['lastDay'] = filter.type
    }

    if (filter.type === 'lastWeek') {
      data['lastWeek'] = filter.type
    }

    if (filter.type === 'custom') {
      data['startDate'] = filter.startDate
      data['endDate'] = filter.endDate
    }

    const apiUrl = `/web/stores/activity`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getDashboardActivityWithPagination = async (page, pageSize, type) => {
  try {
    let data = {
      type: type,
      page: page,
      pageSize: pageSize,
    }

    const apiUrl = `/web/activity/dashboard`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getStoreCategoriesAndSubCategories = async (storeId) => {
  try {
    const apiUrl = `/web/offer/category/get`

    let data = {
      store_id: storeId,
    }

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const createOffer = async (data) => {
  try {
    let offerData = new FormData()

    if (data.stepCount == 1) {
      offerData = {
        user_id: data.userId,
        store_id: data.storeId,
        media_type: data.fileType,
        stepCount: data.stepCount,
      }
    } else if (data.stepCount == 2) {
      offerData = {
        offer_category: JSON.stringify(data.offerCategory),
        offer_subcategory: JSON.stringify(data.offerSubcategory),
        offer_start_date: data.startDate,
        offer_end_date: data.endDate,
        title: data.title,
        terms_and_conditions: data.termsAndConditions,
        description: data.description,
        offer_tags: JSON.stringify(data.offerTags),
        unique_offer_id: data.unique_offer_id,
        offer_media: data.file,
        offer_id: data.offer_id,
        media_type: data.fileType,
        stepCount: data.stepCount,
        is4By5AspectRatio: data.is4By5AspectRatio,
      }
    }

    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/web/offer/create`

    let response = await axios.post(apiUrl, offerData, {
      headers: {
        'Content-Type': `multipart/form-data;`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.response.data.message)

    return error.response.data
  }
}

export const updateOffer = async (data) => {
  try {
    let offerData = new FormData()

    if (data.stepCount == 1) {
      offerData = {
        user_id: data.userId,
        store_id: data.storeId,
        media_type: data.fileType,
        stepCount: data.stepCount,
      }
    } else if (data.stepCount == 2) {
      offerData = {
        offer_category: JSON.stringify(data.offerCategory),
        offer_subcategory: JSON.stringify(data.offerSubcategory),
        offer_start_date: data.startDate,
        offer_end_date: data.endDate,
        title: data.title,
        terms_and_conditions: data.termsAndConditions,
        description: data.description,
        offer_tags: JSON.stringify(data.offerTags),
        unique_offer_id: data.unique_offer_id,
        offer_media: data.file,
        offer_id: data.offer_id,
        media_type: data.fileType,
        stepCount: data.stepCount,
        is4By5AspectRatio: data.is4By5AspectRatio,
      }
    }

    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/web/offer/update`

    let response = await axios.post(apiUrl, offerData, {
      headers: {
        'Content-Type': `multipart/form-data;`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error
  }
}

export const createStore = async (data, stepCount) => {
  try {
    let storeData = new FormData()

    if (stepCount == 1) {
      storeData = {
        gender_id: data.genderId,
        stepCount: stepCount,
      }
    } else if (stepCount == 2) {
      data?.store_media.forEach((file, i) => {
        storeData.append('store_media', file)
      })

      data.store_location = {
        lat: data?.store_location.lat.toString(),
        lng: data?.store_location.lng.toString(),
      }

      storeData.append('stepCount', stepCount)
      storeData.append('store_personal_mobile_no', data?.store_personal_mobile_no)
      storeData.append('store_name', data?.store_name)
      storeData.append('store_user_name', data?.store_user_name)
      storeData.append('store_mobile_no', data?.store_mobile_no)
      storeData.append('store_email', data?.store_email)
      storeData.append('store_gst_no', data?.store_gst_no)
      storeData.append('store_address', data?.store_address)
      storeData.append('store_location', JSON.stringify(data?.store_location))
      storeData.append('store_type', data?.store_type)
      storeData.append('store_timing', JSON.stringify(data?.store_timing))
      storeData.append('store_category', JSON.stringify(data?.store_category))
      storeData.append('store_sub_category', JSON.stringify(data?.store_sub_category))
      storeData.append('user_id', data?.user_id)
      storeData.append('tags', JSON.stringify(data?.store_tags))
      storeData.append('description', data?.description)
      storeData.append('store_logo', data?.store_logo)
      storeData.append('unique_user_id', data?.unique_user_id)

      //   storeData = {
      //     ...storeData,
      //     stepCount: stepCount,
      //     store_personal_mobile_no: data?.store_personal_mobile_no,
      //     store_name: data?.store_name,
      //     store_user_name: data?.store_user_name,
      //     store_mobile_no: data?.store_mobile_no,
      //     store_email: data?.store_email,
      //     store_gst_no: data?.store_gst_no,
      //     store_address: data?.store_address,
      //     store_location: JSON.stringify(data?.store_location),
      //     store_type: data?.store_type,
      //     store_timing: JSON.stringify(data?.store_timing),
      //     store_category: JSON.stringify(data?.store_category),
      //     store_sub_category: JSON.stringify(data?.store_sub_category),
      //     user_id: data?.user_id,
      //     tags: JSON.stringify(data?.store_tags),
      //     description: data?.description,
      //     //store_media: data?.store_media,
      //     store_logo: data?.store_logo,
      //     unique_user_id: data?.unique_user_id,
      //   }

      //   data?.store_media.forEach((file, i) => {
      //     storeData = {...storeData, store_media: file}
      //   })
    }

    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/web/stores/create`

    let response = await axios.post(apiUrl, storeData, {
      headers: {
        'Content-Type': `multipart/form-data;`,
        'x-access-token': accessToken,
      },
    })

    console.log('response', response)

    return response.data
  } catch (error) {
    console.log(error)

    return error.response.data
  }
}

export const updateStore = async (data) => {
  try {
    let storeData = new FormData()

    data.store_location = {
      lat: data?.store_location.lat.toString(),
      lng: data?.store_location.lng.toString(),
    }

    storeData = {
      store_personal_mobile_no: data?.store_personal_mobile_no,
      store_name: data?.store_name,
      store_user_name: data?.store_user_name,
      store_mobile_no: data?.store_mobile_no,
      store_email: data?.store_email,
      store_gst_no: data?.store_gst_no,
      store_address: data?.store_address,
      store_location: data?.store_location,
      store_type: data?.store_type,
      store_timing: data?.store_timing,
      store_category: data?.store_category1,
      store_sub_category: data?.store_sub_category,
      user_id: data?.user_id,
      tags: data?.store_tags,
      description: data?.description,
      unique_user_id: data?.unique_user_id,
      store_id: data.store_id,
    }

    const apiUrl = `/web/stores/update`

    let response = await request(apiUrl, API_TYPE.POST, storeData, true, false)

    return response
  } catch (error) {
    console.log(error)

    return error.response.data
  }
}

export const updateStoreLogo = async (storeId, file, unique_user_id) => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    let formData = new FormData()

    formData.append('store_id', storeId)
    formData.append('unique_user_id', unique_user_id)
    formData.append('store_logo', file)

    let baseUrl = process.env.REACT_APP_SERVER_URL + '/api/v1'

    const apiUrl = `${baseUrl}/web/store/update/logo`

    let response = await axios.post(apiUrl, formData, {
      headers: {
        'Content-Type': `multipart/form-data;`,
        'x-access-token': accessToken,
        isencryption: false,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllCategories = async () => {
  try {
    const apiUrl = `/masters/category/get/all`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllSubCategories = async () => {
  try {
    const apiUrl = `/masters/sub-category/get/all`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllCategoriesByTypes = async (type) => {
  try {
    const apiUrl = `/masters/category/get/types`

    let data = {}

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAddressFromLatLng = async (latLng) => {
  try {
    const apiUrl = `/users/store/address/get`

    let response = await request(apiUrl, API_TYPE.POST, latLng, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getStoreUpdateHistory = async (page, pageSize, storeId) => {
  try {
    const apiUrl = `/web/stores/update-history/get`

    let data = {
      page: page,
      pageSize: pageSize,
      store_id: storeId,
    }

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllSubCategoriesUsingCategoryId = async (categoryIds) => {
  try {
    const apiUrl = `/masters/sub-category/get/category`

    let data = {
      category_ids: categoryIds,
    }

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const createCategories = async (name, order) => {
  try {
    let data = {
      name,
      order,
      type: 'service',
      status: true,
    }

    const apiUrl = `/masters/category/create`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateStoreSettings = async (data) => {
  try {
    const apiUrl = `/web/store/notification/update`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getStoreSettings = async (userId) => {
  try {
    const apiUrl = `/web/store/notification/get`

    let response = await request(apiUrl, API_TYPE.POST, {user_id: userId}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateCategories = async (category_id, name) => {
  try {
    let data = {
      category_id,
      name: name,
    }

    const apiUrl = `/masters/category/update`

    let response = await request(apiUrl, API_TYPE.PUT, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateCategoriesOrder = async (data) => {
  try {
    const apiUrl = `/masters/category/update/bulk`

    let response = await request(apiUrl, API_TYPE.PUT, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const addSubCategories = async (name, order, category_id) => {
  try {
    let data = {
      name,
      order,
      category_id,
    }

    const apiUrl = `/masters/sub-category/create`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateSubCategoriesOrder = async (data) => {
  try {
    const apiUrl = `/masters/sub-category/update/bulk`

    let response = await request(apiUrl, API_TYPE.PUT, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const removeCategories = async (interestId) => {
  try {
    let data = {
      interestId,
    }

    const apiUrl = `/masters/category/create`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getUserInterest = async (userID) => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/users/${userID}/interest`

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const addUserInterest = async (userID, interestId) => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    let formdata = new FormData()
    formdata = {
      interestId: interestId,
    }

    const apiUrl = `${APIURL}/users/${userID}/interest`

    let response = await axios.post(apiUrl, formdata, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const removeUserInterest = async (userID, interestId) => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    let formdata = new FormData()
    formdata = {
      interestId: interestId,
    }

    const apiUrl = `${APIURL}/users/${userID}/interest`

    let response = await axios.delete(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
      data: formdata,
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getCategoriesWithSubCategory = async () => {
  try {
    const apiUrl = `/masters/category/sub-category`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const createUserQuestionAnswerForProfile = async (userID, questionID, answerID) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    let formdata = new FormData()
    formdata = {
      questionId: questionID,
      answerId: answerID,
    }

    const apiUrl = `${APIURL}/users/${userID}/questions`

    let response = await axios.post(apiUrl, formdata, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateUserQuestionAnswerForProfile = async (userID, questionID, answerID) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    let formdata = new FormData()
    formdata = {
      questionId: questionID,
      answerId: answerID,
    }

    const apiUrl = `${APIURL}/users/${userID}/questions`

    let response = await axios.put(apiUrl, formdata, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const deleteUserQuestionAnswerForProfile = async (
  userID,
  questionID,
  answerID,
  userQuestionId
) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    let formdata = new FormData()
    formdata = {
      questionId: questionID,
      answerId: answerID,
    }

    const apiUrl = `${APIURL}/users/${userID}/questions/${userQuestionId}`

    let response = await axios.delete(apiUrl, {
      headers: {
        'Content-Type': `multipart/form-data;`,
        'x-access-token': accessToken,
      },
      data: formdata,
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getUserMedia = async (userID, page, pageSize) => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/users/${userID}/profile/media?page=${page}&pageSize=${pageSize}`

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updatemultiMediaActionForMedia = async (userID, mediaIDArray, action) => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    let body = {
      mediaIds: mediaIDArray,
      action: action,
    }

    const apiUrl = `${APIURL}/users/${userID}/media/admin`

    let response = await axios.put(apiUrl, body, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateMediaActionForUserMedia = async (userID, mediaID) => {
  try {
    let data = {
      isProfileImage: true,
      id: mediaID,
      userId: userID,
    }

    const apiUrl = `/web/users/media/update`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const removeMediaActionForUserMedia = async (userID, mediaID) => {
  try {
    const apiUrl = `/web/users/media/delete`

    let response = await request(apiUrl, API_TYPE.POST, {userId: userID, id: mediaID}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const createMediaActionForUserMedia = async (fileData, userID, userType) => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    let formData = new FormData()

    formData.append('userId', userID)

    fileData.forEach((file, i) => {
      const fileName = `${userType}_${userID}_${i}.webp`
      formData.append('profileMedia', file, fileName)
    })

    let baseUrl = process.env.REACT_APP_SERVER_URL + '/api/v1'

    const apiUrl = `${baseUrl}/web/users/upload/profiles`

    let response = await axios.post(apiUrl, formData, {
      headers: {
        'Content-Type': `multipart/form-data;`,
        'x-access-token': accessToken,
        isencryption: false,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateStoreMedia = async (fileData, mediaId, storeId, action, unique_user_id) => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    let formData = new FormData()

    formData.append('store_id', storeId)
    formData.append('action', action)

    if (action === 'update') {
      formData.append('unique_user_id', unique_user_id)

      fileData.forEach((file) => {
        formData.append('store_media', file)
      })
    } else if (action === 'delete') {
      formData.append('store_media_id', mediaId)
    }

    const apiUrl = `${APIURL}/web/store/media/update`

    let response = await axios.post(apiUrl, formData, {
      headers: {
        'Content-Type': `multipart/form-data;`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const setMediaAsAStoryForUserMedia = async (userID, mediaId) => {
  try {
    const apiUrl = `/web/users/media/upload/story`

    let response = await request(apiUrl, API_TYPE.POST, {userId: userID, id: mediaId}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getOfferHistory = async (storeId, page, pageSize, filter) => {
  try {
    let data = {
      store_id: storeId,
      page: page,
      pageSize: pageSize,
      history_title: filter.historyTitle,
    }

    if (filter.startDate && filter.endDate) {
      data['start_date'] = filter.startDate
      data['end_date'] = filter.endDate
    }

    if (filter.historyTitle) {
      data['history_title'] = filter.historyTitle
    }

    const apiUrl = `/web/store/offer/history`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getUserCreditsHistoryWithPagination = async (
  userID,
  page,
  pageSize,
  creditType,
  filterValue,
  historyType
) => {
  try {
    let data = {userId: userID, page: page, pageSize: pageSize, type: creditType}
    if (filterValue.creditTitle) {
      data['creditHistoryTitle'] = filterValue.creditTitle
    }

    if (filterValue.startDate && filterValue.endDate) {
      data['startDate'] = filterValue.startDate
      data['endDate'] = filterValue.endDate
    }

    if (historyType) {
      data['historyType'] = historyType
    }

    const apiUrl = `/web/users/credits/get`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getUserPurchaseHistoryWithPagination = async (userID, page, pageSize) => {
  try {
    let formdata = new FormData()
    formdata = {
      store_id: userID,
      page: page,
      pageSize: pageSize,
    }

    const apiUrl = `/web/store/purchase/history`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllOfferUsingStoreId = async (storeId, offerStatus, page, pageSize) => {
  try {
    let formdata = new FormData()
    formdata = {
      storeId: storeId,
      page: page,
      pageSize: pageSize,
    }

    if (offerStatus !== 'all') {
      formdata['offerStatus'] = offerStatus
    }

    const apiUrl = `/web/offers/store/get/all`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllOffer = async (offerStatus, page, pageSize, filter) => {
  try {
    let formdata = new FormData()
    formdata = {
      page: page,
      pageSize: pageSize,
      filter: filter,
    }

    if (offerStatus !== 'all') {
      formdata['offerStatus'] = offerStatus
    }

    const apiUrl = `/web/offers/get/all`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const UpdateUserDetailsByUID = async (UID, data, fromEditUser, file) => {
  try {
    // let formdata = {
    //   user_id: UID,
    //   mobile_no: data.mobileNo,
    //   full_name: data.fullName,
    //   gender_id: parseInt(data.gender),
    //   category: data?.category,
    // }

    let formdata = new FormData()

    if (fromEditUser) {
      formdata = {
        user_id: UID,
        mobile_no: data.mobileNo,
        full_name: data.fullName,
        gender_id: parseInt(data.gender),
        category: data?.category,
      }
    } else {
      formdata.append('unique_user_id', UID)
      formdata.append('user_id', UID)
      formdata.append('profile', file)
      formdata.append('mobile_no', data.mobileNo)
    }

    let baseUrl = process.env.REACT_APP_SERVER_URL + '/api/v1'

    const apiUrl = `${baseUrl}/web/user/update`

    let accessToken = localStorage.getItem('accessToken')

    let response = await axios.post(apiUrl, formdata, {
      headers: {
        'Content-Type': `multipart/form-data;`,
        'x-access-token': accessToken,
        isencryption: false,
      },
    })

    return response.data
  } catch (error) {
    return error.response.data
  }
}

export const UpdateVerifyStatusByUID = async (UID, flag) => {
  try {
    let formdata = new FormData()
    formdata = {
      isVerify: flag,
    }

    const apiUrl = `/web/users/update/${UID}`

    let response = await request(apiUrl, API_TYPE.PUT, formdata, true, false)

    return response
  } catch (error) {
    return error.response.data
  }
}

export const UpdateSpotlightStatusByUID = async (UID, duration, type) => {
  try {
    let formData = new FormData()
    formData = {
      duration: duration,
      type: type,
      userId: UID,
    }

    const apiUrl = `/web/users/spotlight/update`

    let response = await request(apiUrl, API_TYPE.PUT, formData, true, false)

    return response
  } catch (error) {
    return error.response.data
  }
}

export const AddOrUpdateCreditByUserId = async (userId, type, credit) => {
  try {
    let formData = new FormData()
    formData = {
      type: type,
      credit: credit,
      userId: userId,
    }

    const apiUrl = `/web/users/send/credit`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    return error.response.data
  }
}

export const AddOrUpdateDiamondsByUserId = async (userId, type, diamond) => {
  try {
    let formData = new FormData()
    formData = {
      type: type,
      diamond: diamond,
      userId: userId,
    }

    const apiUrl = `/web/users/send/diamond`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    return error.response.data
  }
}

export const AddOrUpdatePremiumByUID = async (
  UID,
  type,
  days,
  premiumPackageAmountId,
  paymentVia
) => {
  try {
    let formData = new FormData()
    formData = {
      userId: UID,
      type: type,
      days: days,
      premiumPackageAmountId: premiumPackageAmountId,
      paymentVia: paymentVia,
    }

    const apiUrl = `/web/users/send/premium`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    return error.response.data
  }
}

// /:userId/remove/:pkgId/premium

export const removePremium = async (userId, premiumPackageAmountId) => {
  try {
    let formData = new FormData()
    formData = {
      userId: userId,
      pkgId: premiumPackageAmountId,
    }

    const apiUrl = `/web/users/remove/premium`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    return error.response.data
  }
}

export const getSpotlightUsers = async (page, pageSize, userType) => {
  try {
    let formData = {
      page: page,
      pageSize: pageSize,
      registerFrom: userType,
    }

    const apiUrl = `/web/user/spotlight/get`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    return error.response.data
  }
}

export const removeSpotlightUser = async (userID) => {
  try {
    let formData = {
      userId: userID,
    }

    const apiUrl = `/web/user/spotlight/remove`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

/*For Chats */
export const getMessagesByUserID = async (userID, chatroomID, page, pageSize) => {
  try {
    let formData = {
      user_id: userID,
      chat_room_id: chatroomID,
      page: page,
      pageSize: pageSize,
    }

    const apiUrl = `/web/communications/chat-member/message/get`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getChatMemberByUserID = async (userID, page, pageSize, search, is_store) => {
  try {
    let formData = {
      user_id: userID,
      page: page,
      pageSize: pageSize,
      search: search,
      is_store: is_store,
    }

    const apiUrl = `/web/communications/chat-member/get`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllGifts = async (page, pageSize) => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/masters/gifts/web`

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllGiftsCategory = async () => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/masters/gifts-category`

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const sendCreditInChat = async (senderID, receiverId, credit) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    let formData = new FormData()
    formData = {
      receiverId: receiverId,
      credit: credit,
    }

    const apiUrl = `${APIURL}/users/${senderID}/send/credit`

    let response = await axios.post(apiUrl, formData, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const pinOrLikeChatMember = async (userID, roomID, chatID, action, currentActionValue) => {
  try {
    let formdata = {
      userId: userID,
      chatRoomId: roomID,
      chatMemberId: chatID,
    }
    if (action === 'pin') {
      formdata['isAdminPinned'] = currentActionValue
    } else if (action === 'like') {
      formdata['isAdminLiked'] = currentActionValue
    }

    const apiUrl = `/web/communications/chatMembers/update`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

/*for story */

export const getAllUserStory = async (userId) => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/users/1/stories/view/${userId}`

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const CreateUserStory = async (fileData, userId, userType) => {
  try {
    let mediaType = fileData.type.split('/')[0]
    let formData = new FormData()

    // userType = "n"  = normal users
    // userType = "a"  = anonymous users

    let fileName = userType + '_' + userId + '.' + fileData.name.split('.').pop()
    formData.append('media', fileData, fileName)
    formData.append(`mediaType`, mediaType == 'image' ? 'photo' : mediaType)

    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/users/${userId}/stories`

    let response = await axios.post(apiUrl, formData, {
      headers: {
        'Content-Type': `multipart/form-data;`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const deleteUserStory = async (userId, mediaId) => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/users/${userId}/stories/${mediaId}`

    let response = await axios.delete(apiUrl, {
      headers: {
        'Content-Type': `multipart/form-data;`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const UpdateUserStory = async (storyCredit, userId, storyId) => {
  try {
    storyCredit = parseInt(storyCredit)
    let formData = new FormData()
    if (storyCredit !== 0) {
      formData = {
        isPrivate: true,
        storyCredit: storyCredit,
      }
    } else {
      formData = {
        isPrivate: false,
        storyCredit: storyCredit,
      }
    }

    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/users/${userId}/stories/${storyId}`

    let response = await axios.put(apiUrl, formData, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const ReUploadUserStory = async (userId, storyId) => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/users/${userId}/stories/${storyId}/re-upload`

    let response = await axios.post(
      apiUrl,
      {},
      {
        headers: {
          'Content-Type': `application/json`,
          'x-access-token': accessToken,
        },
      }
    )

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllMedia = async (page, pageSize, userID, userName) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
      userId: userID,
      userName: userName,
    }

    const apiUrl = `/web/profile/media`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const deleteSelectedMedia = async (MediaId) => {
  try {
    let formData = {
      mediaIds: MediaId,
    }

    const apiUrl = `/web/users/media/delete/multiple`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllStories = async (page, pageSize, isPrivate, userID, userName) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    const apiUrl = `${APIURL}/users/all/stories?page=${page}&pageSize=${pageSize}&isPrivate=${isPrivate}&userId=${userID}&userName=${userName}`

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const deleteSelectedStory = async (MediaId) => {
  try {
    let formData = {
      storyIds: MediaId,
    }

    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/users/delete/all/stories`

    let response = await axios.put(apiUrl, formData, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const ReUploadSelectedStory = async (MediaId) => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    let formData = {
      storyIds: MediaId,
    }

    const apiUrl = `${APIURL}/users/re-upload/all/stories`

    let response = await axios.put(apiUrl, formData, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

// gifts plugin

export const getAllGiftCategory = async () => {
  try {
    const apiUrl = `/masters/gifts-category/`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const CreateGiftsCategory = async (name) => {
  try {
    let formData = new FormData()
    formData = {
      name: name,
    }

    const apiUrl = `/masters/gifts-category/`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateGiftsCategory = async (name, giftCategoryId) => {
  try {
    let formData = new FormData()
    formData = {
      name: name,
      giftCategoryId: giftCategoryId,
    }

    const apiUrl = `/masters/gifts-category/update`

    let response = await request(apiUrl, API_TYPE.PUT, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const deleteGiftsCategory = async (giftCategoryId) => {
  try {
    let data = {
      giftCategoryId: giftCategoryId,
    }

    const apiUrl = `/masters/gifts-category/delete`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllGift = async () => {
  try {
    const apiUrl = `/masters/gifts-category/with/gifts`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const CreateGift = async (name, categoryId, categoryName, credit, giftFile) => {
  try {
    let formData = new FormData()

    let fileName = categoryName + '.' + giftFile.name.split('.').pop()
    formData.append('gift', giftFile, fileName) // fileData[i].name .split(".")[0] + ".webp"
    formData.append(`credit`, credit)
    formData.append(`giftCategoryId`, categoryId)
    formData.append(`name`, name)

    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/masters/gifts-category/gifts/create`

    let response = await axios.post(apiUrl, formData, {
      headers: {
        'Content-Type': `multipart/form-data;`,
        'x-access-token': accessToken,
        isencryption: false,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateGifts = async (name, categoryId, categoryName, credit, giftFile, giftId) => {
  try {
    let formData = new FormData()

    if (giftFile !== undefined && giftFile !== null && giftFile.length !== 0) {
      let fileName = categoryName + '.' + giftFile.name.split('.').pop()
      formData.append('gift', giftFile, fileName)
    }
    // fileData[i].name .split(".")[0] + ".webp"
    formData.append(`credit`, credit)
    formData.append(`giftCategoryId`, categoryId)
    formData.append(`name`, name)
    formData.append(`giftId`, giftId)

    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/masters/gifts-category/gifts/update`

    let response = await axios.put(apiUrl, formData, {
      headers: {
        'Content-Type': `multipart/form-data;`,
        'x-access-token': accessToken,
        isencryption: false,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const deleteGifts = async (giftCategoryId, giftId) => {
  try {
    let formData = {
      giftId: giftId,
    }

    const apiUrl = `/masters/gifts-category/gifts/delete`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

//master plugins

export const getConfigurationByName = async (name) => {
  try {
    const apiUrl = `/masters/configurations/type`

    let response = await request(apiUrl, API_TYPE.POST, {type: name}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateConfigurationByConfigID = async (ConfigID, values, gestureFile) => {
  try {
    let formData = new FormData()

    if (gestureFile === null) {
      formData = {
        values: JSON.stringify(values),
        configurationId: ConfigID,
      }
    } else {
      formData = {
        gesture: gestureFile,
        values: JSON.stringify(values),
        configurationId: ConfigID,
      }
    }

    const apiUrl = `/masters/configurations/update`

    let response = await request(apiUrl, API_TYPE.PUT, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateBannerConfigurationByConfigID = async (ConfigID, values, file) => {
  try {
    let formData = new FormData()
    formData = {
      banner: file,
      values: JSON.stringify(values),
      configurationId: ConfigID,
    }

    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/masters/configurations/update/banner`

    let response = await axios.put(apiUrl, formData, {
      headers: {
        'Content-Type': `multipart/form-data`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateNotificationConfigurationByConfigID = async (ConfigID, values, file) => {
  try {
    let formData = new FormData()
    if (file.isFromBanner) {
      formData = {
        banner: file,
        values: JSON.stringify(values),
        configurationId: ConfigID,
      }
    } else {
      formData = {
        gesture: file,
        values: JSON.stringify(values),
        configurationId: ConfigID,
      }
    }

    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/masters/configurations/notification`

    let response = await axios.put(apiUrl, formData, {
      headers: {
        'Content-Type': `multipart/form-data`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

// site-pricing plugin

export const getCreditAndPremiumPackageAmountPlans = async () => {
  try {
    const apiUrl = `/masters/packages/credits/both`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getOfferPackageAmountPlans = async () => {
  try {
    const apiUrl = `/masters/offer-packages/get/all`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const CreateOfferPackageAmountPlan = async (
  count,
  totalAmount,
  amount,
  name,
  isMostPopular,
  description
) => {
  try {
    let formData = new FormData()

    formData = {
      total_amount: totalAmount,
      amount: amount,
      offer_count: count,
      name: name,
      is_most_popular: isMostPopular,
      description: description,
    }

    const apiUrl = `/masters/offer-packages/create`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateOfferPackageAmountPlan = async (
  pkgId,
  count,
  totalAmount,
  amount,
  name,
  isMostPopular,
  description
) => {
  try {
    let formData = new FormData()
    formData = {
      total_amount: totalAmount,
      amount: amount,
      name: name,
      offer_count: count,
      offer_package_id: pkgId,
      is_most_popular: isMostPopular,
      description: description,
    }

    const apiUrl = `/masters/offer-packages/update`

    let response = await request(apiUrl, API_TYPE.PUT, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateOfferCountInStore = async (type, offer_count, store_id) => {
  try {
    let formData = new FormData()
    formData = {
      type: type,
      offer_count: offer_count,
      store_id: store_id,
    }

    const apiUrl = `/web/store/update/offer-count`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const verifyStore = async (action, user_id) => {
  try {
    let formData = new FormData()
    formData = {
      action: action,
      user_id: user_id,
    }

    const apiUrl = `/web/store/verify`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getPremiumPackageAmountPlans = async () => {
  try {
    const apiUrl = `/masters/packages/premium?fromWeb=true`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const CreatePremiumPackageAmountPlan = async (days, totalAmount, amount, pkgName) => {
  try {
    let formData = new FormData()
    formData = {
      days: days,
      totalAmount: totalAmount,
      amount: amount,
      premiumPackageName: pkgName,
    }

    const apiUrl = `/masters/packages/premium/`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updatePremiumPackageAmountPlan = async (pkgId, days, totalAmount, amount, pkgName) => {
  try {
    let formData = new FormData()
    formData = {
      days: days,
      totalAmount: totalAmount,
      amount: amount,
      premiumPackageName: pkgName,
      premiumPackageAmountId: pkgId,
    }

    const apiUrl = `/masters/packages/premium/`

    let response = await request(apiUrl, API_TYPE.PUT, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getCreditPackages = async () => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    const apiUrl = `${APIURL}/masters/packages/credits`

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

//credit package details
export const CreateCreditPackages = async (heading, description, icon) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    const apiUrl = `${APIURL}/masters/packages/credits`

    let formData = new FormData()
    formData = {
      heading: heading,
      description: description,
      icon: icon,
    }

    let response = await axios.post(apiUrl, formData, {
      headers: {
        'Content-Type': `multipart/form-data`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const deleteCreditPackages = async (creditPackageId) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    const apiUrl = `${APIURL}/masters/packages/credits/${creditPackageId}`

    let response = await axios.delete(apiUrl, {
      headers: {
        'Content-Type': `application/x-www-form-urlencoded`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateCreditPackages = async (data, icon) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    const apiUrl = `${APIURL}/masters/packages/credits/${data.creditPackageId}`

    let formData
    if (icon.length === 0) {
      formData = {
        heading: data.heading,
        description: data.description,
      }
    } else {
      formData = {
        heading: data.heading,
        description: data.description,
        icon: icon,
      }
    }

    let response = await axios.put(apiUrl, formData, {
      headers: {
        'Content-Type': `multipart/form-data;`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

//get users orders
export const getUserOrdersList = async (page, pageSize, filter, tabValue) => {
  let {
    search,
    startDate,
    endDate,
    searchType,
    searchDateType,
    orderType,
    transactionStatus,
    modeOfPayment,
    offerPlans,
  } = filter

  try {
    let replacements = {
      'Google Pay': 'google pay',
      Phonepay: 'phonepay',
      Razorpay: 'razorpay',
      'Apple Pay': 'apple pay',
      'Cash Free': 'cashfree',
    }

    modeOfPayment = modeOfPayment.map((method) => replacements[method] || method)

    let transactionStatusReplacements = {
      Pending: 'pending',
      Success: 'success',
      Failed: 'failed',
    }

    transactionStatus = transactionStatus.map(
      (method) => transactionStatusReplacements[method] || method
    )

    let data = {
      search,
      startDate,
      endDate,
      searchType,
      tabValue,
      orderType,
      searchDateType,
      transactionStatus,
      modeOfPayment,
      OfferPlanIds: offerPlans,
      page: page,
      pageSize: pageSize,
    }

    const apiUrl = `/web/purchase/order`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getGuestUserList = async (filter, page, pageSize) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
    }

    if (filter.startDate && filter.endDate) {
      data['startDate'] = filter.startDate
      data['endDate'] = filter.endDate
    }

    if (filter.gender) {
      data['gender'] = filter.gender
    }

    if (filter.country) {
      data['country'] = filter.country
    }

    if (filter.state) {
      data['state'] = filter.state
    }

    if (filter.city) {
      data['city'] = filter.city
    }

    const apiUrl = `/web/user/guest/all`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

//verification system

export const getStoreVerificationList = async (page, pageSize, filter) => {
  try {
    const apiUrl = `/web/stores/verification/list`

    let data = {
      page,
      pageSize,
    }

    if (filter.search) {
      data['search'] = filter.search
    }

    if (filter.verifyStatus) {
      data['verification_status'] = filter.verifyStatus
    }

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getStoreApprovalList = async (page, pageSize, filter) => {
  try {
    const apiUrl = `/web/stores/store-approval/get`

    let data = {
      page,
      pageSize,
    }

    if (filter.search) {
      data['search'] = filter.search
    }

    if (filter.startDate) {
      data['startDate'] = filter.startDate
    }

    if (filter.endDate) {
      data['endDate'] = filter.endDate
    }

    if (filter.updateStatus) {
      data['updateStatus'] = filter.updateStatus
    }

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getOfferApprovalList = async (page, pageSize, filter) => {
  try {
    const apiUrl = `/web/offers/offer-approval/get`

    let data = {
      page,
      pageSize,
    }

    if (filter.search) {
      data['search'] = filter.search
    }

    if (filter.startDate) {
      data['startDate'] = filter.startDate
    }

    if (filter.endDate) {
      data['endDate'] = filter.endDate
    }

    if (filter.updateStatus) {
      data['updateStatus'] = filter.updateStatus
    }

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateStoreApproval = async (storeId, action, reason) => {
  try {
    let formData = new FormData()
    if (action === 'verify' || action === 'update') {
      formData = {
        action: action,
        store_id: storeId,
      }
    } else {
      formData = {
        action: action,
        reject_reason: reason,
        store_id: storeId,
      }
    }

    const apiUrl = `/web/store/update/status`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateUserVerification = async (userID, verificationId, verifyStatus, reason) => {
  try {
    let formData = new FormData()
    if (verifyStatus === 'verified') {
      formData = {
        verifyStatus: verifyStatus,
        id: verificationId,
        userId: userID,
      }
    } else {
      formData = {
        verifyStatus: verifyStatus,
        reason: reason,
        id: verificationId,
        userId: userID,
      }
    }

    const apiUrl = `/web/users/verification`

    let response = await request(apiUrl, API_TYPE.PUT, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

// withdrawal requests

export const getUserWithDrawalRequestsList = async (page, pageSize, filter) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
    }

    if (filter.search !== undefined) {
      data['search'] = filter.search
    }

    if (filter.userSearch !== undefined) {
      data['userSearch'] = filter.userSearch
    }

    if (filter.transactionStatus !== undefined) {
      data['transactionStatus'] = filter.transactionStatus
    }

    if (filter.startDate && filter.endDate) {
      data['startDate'] = filter.startDate
      data['endDate'] = filter.endDate
    }

    const apiUrl = `/web/withdraw/get`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateUserWithDrawalRequests = async (
  userId,
  withdrawalRequestId,
  transactionStatus,
  reason,
  credit,
  transactionId,
  adminUserId,
  amount
) => {
  try {
    let formData = new FormData()
    if (transactionStatus === 'completed') {
      formData = {
        transactionStatus: transactionStatus,
        transactionId: transactionId,
        adminUserId: adminUserId,
        credit: credit,
        withdrawMoney: amount,
        withdrawId: withdrawalRequestId,
        userId: userId,
      }
    } else {
      formData = {
        transactionStatus: transactionStatus,
        reason: reason,
        credit: credit,
        adminUserId: adminUserId,
        withdrawMoney: amount,
        withdrawId: withdrawalRequestId,
        userId: userId,
      }
    }

    const apiUrl = `/web/withdraw/update`

    let response = await request(apiUrl, API_TYPE.PUT, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

// anonymous users

export const getAllAnonymousUser = async (query) => {
  try {
    const apiUrl = `/web/anonymous/users/allUser?${query}`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllAdminUser = async (query) => {
  try {
    const apiUrl = `/web/admin/users/get?${query}`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllUserAnonymousStories = async (page, pageSize, isPrivate, userID, userName) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    const apiUrl = `${APIURL}/anonymous/users/stories?page=${page}&pageSize=${pageSize}&isPrivate=${isPrivate}&userId=${userID}&userName=${userName}`

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllUserAnonymousMedia = async (page, pageSize, userID, userName) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
      userId: userID,
      userName: userName,
    }

    const apiUrl = `/web/anonymous/profile/media`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const createNewAnonymousUser = async (values) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    const apiUrl = `${APIURL}/anonymous/users`

    let formData = new FormData()
    formData = values

    let response = await axios.post(apiUrl, formData, {
      headers: {
        'Content-Type': `application/x-www-form-urlencoded`,
        'x-access-token': accessToken,
      },
    })
    localStorage.setItem('anonymousUserId', response.data.data.userId)
    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const checkUserName = async (userName) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    const apiUrl = `${APIURL}/users/check/username`

    let formData = new FormData()
    formData = {
      userName: userName,
    }

    let response = await axios.post(apiUrl, formData, {
      headers: {
        'Content-Type': `application/x-www-form-urlencoded`,
        'x-access-token': accessToken,
      },
    })
    console.log('2094', response)
    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const UpdateUserProfilePicture = async (UID, fileData) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    let formdata = new FormData()
    formdata = {
      anonymousprofile: fileData,
      fromWeb: true,
    }

    const apiUrl = `${APIURL}/users/update/${UID}`

    let response = await axios.put(apiUrl, formdata, {
      headers: {
        'Content-Type': `multipart/form-data;`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    return error.response.data
  }
}

export const getUserMediaImages = async (uid) => {
  try {
    const apiUrl = `/web/users/profile/media/all/${uid}`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const UpdateUserInterestAndQuestions = async (UID, interests, questions) => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/users/update/${UID}`

    let formData = new FormData()
    formData = {
      interests: JSON.stringify(interests),
      questions: JSON.stringify(questions),
    }

    let response = await axios.put(apiUrl, formData, {
      headers: {
        'Content-Type': `multipart/form-data;`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

// legal information plugins (policy)

export const getAllPolicies = async () => {
  try {
    const apiUrl = `/masters/policies/`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const UpdatePolicy = async (policyId, htmlText) => {
  try {
    const apiUrl = `/masters/policies/${policyId}`

    let formData = new FormData()
    formData = {
      html: htmlText,
    }

    let response = await request(apiUrl, API_TYPE.PUT, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

// anonymous users chat
export const getAllNormalUserChatMembers = async (
  page,
  pageSize,
  search,
  moderatorId,
  tabValue
) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
      tabValue: tabValue,
    }

    if (search.length !== 0) {
      data['search'] = search
    }

    if (moderatorId.length !== 0) {
      data['moderatorId'] = moderatorId
    }

    const apiUrl = `/web/communications/all/app/chatMembers`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

// Update folder structure config
export const UpdateFolderStructurePlugin = async (values, ConfigID) => {
  try {
    let data = {
      values: values,
      type: 'folder_structure',
      category: 'common',
      configId: ConfigID,
    }

    const apiUrl = `/masters/configurations/updateFolderStructureConfig`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

// interaction api start

export const getStoreAllInteractionCount = async (storeId) => {
  try {
    const apiUrl = `/web/stores/interaction/allCount`

    let response = await request(apiUrl, API_TYPE.POST, {storeId}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getLikesMeList = async (userID, page, pageSize) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
      userId: userID,
    }

    const apiUrl = `/web/users/interaction/likes/me`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getVisitMeList = async (userID, page, pageSize) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
      userId: userID,
    }

    const apiUrl = `/web/users/interaction/visit/me`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getMatchUserList = async (userID, page, pageSize) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
      userId: userID,
    }

    const apiUrl = `/web/users/interaction/matched`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getFollowList = async (userId, type, search, is_store, page, pageSize) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
      type: type,
      search: search,
      user_id: userId,
      is_store: is_store,
    }

    const apiUrl = `/web/stores/interaction/follow/get`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getMyVisitList = async (userID, page, pageSize) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
      userId: userID,
    }

    const apiUrl = `/web/users/interaction/visit/my`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

// interaction api end

// admin users api

export const getAllRoles = async () => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/masters/roles/`

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const createAdminUser = async (values) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    const apiUrl = `${APIURL}/web/users/register`

    let formData = new FormData()
    formData = values

    let response = await axios.post(apiUrl, formData, {
      headers: {
        'Content-Type': `application/x-www-form-urlencoded`,
        'x-access-token': accessToken,
      },
    })
    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAdminUserProfile = async (userId) => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/web/users/${userId}`

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateAdminUser = async (values, userId) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    const apiUrl = `${APIURL}/web/users/${userId}`

    let formData = new FormData()
    formData = values

    let response = await axios.put(apiUrl, formData, {
      headers: {
        'Content-Type': `application/x-www-form-urlencoded`,
        'x-access-token': accessToken,
      },
    })
    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const deleteAdminUser = async (userId) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    const apiUrl = `${APIURL}/web/users/${userId}`

    let response = await axios.delete(apiUrl, {
      headers: {
        'Content-Type': `application/x-www-form-urlencoded`,
        'x-access-token': accessToken,
      },
    })
    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const activeInactiveAdminUser = async (userIDs, status) => {
  try {
    let formdata = new FormData()
    formdata = {
      userIds: userIDs,
      status: status,
    }

    const apiUrl = `/web/user/admin/update/status`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getChatModeratorList = async () => {
  try {
    const apiUrl = `/web/users/chat-moderators/get`

    let response = await request(apiUrl, API_TYPE.POST, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const updateSingleModerator = async (userId, newModeratorId) => {
  try {
    let data = {
      userId: userId,
      newModeratorId: newModeratorId,
    }

    const apiUrl = `/web/users/update-single-moderator`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateModeratorAndAssignEqually = async (allUsers, oldModeratorId) => {
  try {
    let data = {
      allUsers: allUsers,
      oldModeratorId: oldModeratorId,
    }

    let accessToken = localStorage.getItem('accessToken')
    const apiUrl = `${APIURL}/web/users/updateModeratorAndDivideEqually`

    let response = await axios.post(apiUrl, data, {
      headers: {
        'Content-Type': `application/x-www-form-urlencoded`,
        'x-access-token': accessToken,
      },
    })
    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateMultipleUserModerator = async (allUsers, newModeratorId) => {
  try {
    let data = {
      allUsers: allUsers,
      newModeratorId: newModeratorId,
    }

    let accessToken = localStorage.getItem('accessToken')
    const apiUrl = `${APIURL}/web/users/updateMultipleUserModerator`

    let response = await axios.post(apiUrl, data, {
      headers: {
        'Content-Type': `application/x-www-form-urlencoded`,
        'x-access-token': accessToken,
      },
    })
    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const sendNotificationToSelectedUser = async (userIds, message, title, imageUrl) => {
  try {
    let data = {
      userIds: userIds,
      message: message,
      title: title,
      imageUrl: imageUrl,
    }

    const apiUrl = `/web/users/send/notification`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

// support Reason screen

export const getAllSupportReasons = async () => {
  try {
    const apiUrl = `/masters/support/reason`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const createSupportReasons = async (reason) => {
  try {
    let formdata = {
      reason: reason,
    }

    console.log('formdata', formdata)

    const apiUrl = `/masters/support/reason`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateSupportReasons = async (supportReasonId, reason) => {
  try {
    let formdata = {
      reason: reason,
    }

    const apiUrl = `/masters/support/reason/${supportReasonId}`

    let response = await request(apiUrl, API_TYPE.PUT, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

// support screen

export const getAllUsersSupports = async (page, pageSize) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
    }

    const apiUrl = `/web/masters/support/get`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getUsersSupportsChat = async (supportId, page, pageSize) => {
  try {
    let formdata = new FormData()
    formdata = {
      support_id: supportId,
      page: page,
      pageSize: pageSize,
      is_web: true,
    }

    const apiUrl = `/masters/support/get/messages`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const UpdateSupportTicketStatus = async (supportId) => {
  try {
    let formdata = new FormData()
    formdata = {
      support_status: 'completed',
    }

    const apiUrl = `/masters/support/${supportId}/update`

    let response = await request(apiUrl, API_TYPE.PUT, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllAnalytics = async (page, pageSize, filter) => {
  try {
    let formdata = new FormData()
    formdata = {
      page: page,
      pageSize: pageSize,
      type: filter.duration,
    }

    if (filter.startDate && filter.endDate) {
      formdata['startDate'] = filter.startDate
      formdata['endDate'] = filter.endDate
    }

    const apiUrl = `/web/analytics/all`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const createAnalytics = async (marketingCost) => {
  try {
    let formdata = new FormData()
    formdata = {
      marketingCost: marketingCost,
    }

    const apiUrl = `/web/analytics/create`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateAnalytics = async (analytics) => {
  try {
    const apiUrl = `/web/analytics/update`

    let response = await request(apiUrl, API_TYPE.PUT, analytics, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const recalculateDailyAnalytics = async (analyticsId) => {
  try {
    let data = {
      analyticsId: analyticsId,
    }

    const apiUrl = `/web/analytics/recalculate`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const recalculateAllAnalytics = async () => {
  try {
    const apiUrl = `/web/analytics/recalculate/all`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getTodaysAnalytics = async () => {
  try {
    const apiUrl = `/web/analytics/currentAnalytics`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getCurrentWeekAnalytics = async () => {
  try {
    const apiUrl = `/web/analytics/currentWeek`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getCurrentMonthAnalytics = async () => {
  try {
    const apiUrl = `/web/analytics/currentMonth`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getCurrentYearAnalytics = async () => {
  try {
    const apiUrl = `/web/analytics/currentYear`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getInstallAnalytics = async (filter, dateFormat) => {
  let {duration, startDate, endDate, view} = filter
  try {
    let data = {
      duration: duration,
      view: view,
      format: dateFormat,
    }

    if (duration !== 'today' && duration !== 'yesterday') {
      data['startDate'] = moment(startDate).format('YYYY-MM-DD')
      data['endDate'] = moment(endDate).format('YYYY-MM-DD')
    }

    const apiUrl = `/web/analytics/install`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getUserAnalytics = async (filter, dateFormat) => {
  let {duration, startDate, endDate, view} = filter
  try {
    let data = {
      duration: duration,
      view: view,
      format: dateFormat,
    }

    if (duration !== 'today' && duration !== 'yesterday') {
      data['startDate'] = moment(startDate).format('YYYY-MM-DD')
      data['endDate'] = moment(endDate).format('YYYY-MM-DD')
    }

    const apiUrl = `/web/analytics/user`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getStoreAnalytics = async (filter, dateFormat) => {
  let {duration, startDate, endDate, view} = filter
  try {
    let data = {
      duration: duration,
      view: view,
      format: dateFormat,
    }

    if (duration !== 'today' && duration !== 'yesterday') {
      data['startDate'] = moment(startDate).format('YYYY-MM-DD')
      data['endDate'] = moment(endDate).format('YYYY-MM-DD')
    }

    const apiUrl = `/web/analytics/store`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getParticularStoreAnalytics = async (filter, storeId) => {
  let {type, startDate, endDate} = filter
  try {
    let data = {
      type: type,
      start_date: startDate,
      end_date: endDate,
      store_id: storeId,
    }

    const apiUrl = `/web/store/analytics/get`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getParticularStoreStaticAnalytics = async (storeId) => {
  try {
    let data = {
      store_id: storeId,
    }

    const apiUrl = `/web/store/analytics/static/get`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getCreditOrderAnalytics = async (
  filter,
  dateFormat,
  orderTypeFilter,
  paymentModeFilter
) => {
  let {duration, startDate, endDate, view, chartType} = filter
  try {
    orderTypeFilter = Object.keys(orderTypeFilter).filter((key) => orderTypeFilter[key] === true)

    paymentModeFilter = Object.keys(paymentModeFilter).filter(
      (key) => paymentModeFilter[key] === true
    )

    let replacedPaymentMethods = paymentModeFilter.map((method) => {
      if (method === 'googlePay') {
        return 'google pay'
      } else if (method === 'phonePay') {
        return 'phonepay'
      } else if (method === 'razorPay') {
        return 'razorpay'
      } else if (method === 'applePay') {
        return 'apple pay'
      } else {
        return method
      }
    })

    let data = {
      chartType: chartType,
      duration: duration,
      type: orderTypeFilter,
      view: view,
      format: dateFormat,
      paymentModes: replacedPaymentMethods,
    }

    if (duration !== 'today' && duration !== 'yesterday') {
      data = {
        ...data,
        startDate: moment(startDate).format('YYYY-MM-DD'),
        endDate: moment(endDate).format('YYYY-MM-DD'),
      }
    }

    const apiUrl = `/web/analytics/creditOrder`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getPremiumOrderAnalytics = async (
  filter,
  dateFormat,
  orderTypeFilter,
  paymentModeFilter
) => {
  let {duration, startDate, endDate, view, chartType} = filter
  try {
    orderTypeFilter = Object.keys(orderTypeFilter).filter((key) => orderTypeFilter[key] === true)

    paymentModeFilter = Object.keys(paymentModeFilter).filter(
      (key) => paymentModeFilter[key] === true
    )

    let replacedPaymentMethods = paymentModeFilter.map((method) => {
      if (method === 'googlePay') {
        return 'google pay'
      } else if (method === 'phonePay') {
        return 'phonepay'
      } else if (method === 'razorPay') {
        return 'razorpay'
      } else if (method === 'applePay') {
        return 'apple pay'
      } else {
        return method
      }
    })

    let data = {
      chartType: chartType,
      duration: duration,
      type: orderTypeFilter,
      view: view,
      format: dateFormat,
      paymentModes: replacedPaymentMethods,
    }

    if (duration !== 'today' && duration !== 'yesterday') {
      data = {
        ...data,
        startDate: moment(startDate).format('YYYY-MM-DD'),
        endDate: moment(endDate).format('YYYY-MM-DD'),
      }
    }

    const apiUrl = `/web/analytics/premiumOrder`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getTotalOrderAnalytics = async (
  filter,
  dateFormat,
  orderTypeFilter,
  paymentModeFilter
) => {
  let {duration, startDate, endDate, view} = filter
  try {
    orderTypeFilter = Object.keys(orderTypeFilter).filter((key) => orderTypeFilter[key] === true)

    paymentModeFilter = Object.keys(paymentModeFilter).filter(
      (key) => paymentModeFilter[key] === true
    )

    let replacedPaymentMethods = paymentModeFilter.map((method) => {
      if (method === 'googlePay') {
        return 'google pay'
      } else if (method === 'phonePay') {
        return 'phonepay'
      } else if (method === 'razorPay') {
        return 'razorpay'
      } else if (method === 'applePay') {
        return 'apple pay'
      } else if (method === 'cashFree') {
        return 'cashfree'
      } else {
        return method
      }
    })

    let data = {
      duration: duration,
      type: orderTypeFilter,
      view: view,
      format: dateFormat,
      paymentModes: replacedPaymentMethods,
    }

    if (duration !== 'today' && duration !== 'yesterday') {
      data = {
        ...data,
        startDate: moment(startDate).format('YYYY-MM-DD'),
        endDate: moment(endDate).format('YYYY-MM-DD'),
      }
    }

    const apiUrl = `/web/analytics/totalOrder`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getPackagesAnalytics = async () => {
  try {
    const apiUrl = `/web/analytics/packageAnalytics`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getCountryWiseUserAnalytics = async () => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    let apiUrl = `${APIURL}/masters/analytics/countryWiseUser`

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getStateWiseUserAnalytics = async (countryName, stateFilter) => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    let apiUrl = `${APIURL}/masters/analytics/stateWiseUser?country=${countryName}&stateFilter=${stateFilter}`

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getCityWiseUserAnalytics = async (countryName, stateName, cityFilter) => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    let apiUrl = `${APIURL}/masters/analytics/cityWiseUser?state=${stateName}&country=${countryName}&cityFilter=${cityFilter}`

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getDashboardAnalytics = async () => {
  try {
    const apiUrl = `/web/analytics/analytics-dashboard`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllAdsPlan = async () => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    let apiUrl = `${APIURL}/masters/ads-plan`

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const createAdsPlan = async (data) => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    let formdata = new FormData()
    formdata = {
      type: data.type,
      premiumPlanId: data.premiumPlanId,
      creditAndDays: data.creditAndDays,
      adsType: data.adsType,
    }

    const apiUrl = `${APIURL}/masters/ads-plan`

    let response = await axios.post(apiUrl, formdata, {
      headers: {
        'Content-Type': `application/x-www-form-urlencoded`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateAdsPlan = async (data) => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    let formdata = new FormData()
    formdata = {
      type: data.type,
      premiumPlanId: data.premiumPlanId,
      creditAndDays: data.creditAndDays,
      adsType: data.adsType,
    }

    const apiUrl = `${APIURL}/masters/ads-plan/${data.adsPlanId}`

    let response = await axios.put(apiUrl, formdata, {
      headers: {
        'Content-Type': `application/x-www-form-urlencoded`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const deleteAdsPlan = async (planId) => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/masters/ads-plan/${planId}`

    let response = await axios.delete(apiUrl, {
      headers: {
        'Content-Type': `application/x-www-form-urlencoded`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const scheduleCron = async (type, time, title, message, imageUrl) => {
  try {
    let data = {
      type: type,
      time: time,
      title: title,
      message: message,
      imageUrl: imageUrl,
    }

    let accessToken = localStorage.getItem('accessToken')
    const apiUrl = `${APIURL}/notifications/scheduleCron`

    let response = await axios.post(apiUrl, data, {
      headers: {
        'Content-Type': `application/json`,
        Authorization: `Bearer ${accessToken}`,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getSideBarCount = async () => {
  try {
    const apiUrl = `/web/users/sidebarCount`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllBlockedUserList = async (page, pageSize, storeId, isStore, userId) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
      store_id: storeId,
      is_store: isStore,
      user_id: userId,
    }

    const apiUrl = `/web/users/block/get`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getUserAllStatistics = async () => {
  try {
    const apiUrl = `/web/users/statistics`

    let response = await request(apiUrl, API_TYPE.POST, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getStoreAllStatistics = async () => {
  try {
    const apiUrl = `/web/stores/statistics`

    let response = await request(apiUrl, API_TYPE.POST, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getOffersAllStatistics = async () => {
  try {
    const apiUrl = `/web/offers/statistics`

    let response = await request(apiUrl, API_TYPE.POST, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllAnonymousUserForCreateChatRoom = async (
  page,
  pageSize,
  state,
  userId,
  searchTerm
) => {
  try {
    let data = {page: page, pageSize: pageSize, state: state, userId: userId, search: searchTerm}

    const apiUrl = `/web/anonymous/communications/users/get`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const sendVisitFromAnonymousChat = async (senderId, receiverId) => {
  try {
    let data = {
      senderId: senderId,
      receiverId: receiverId,
    }

    const apiUrl = `/web/anonymous/send/visit`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const sendLikeFromAnonymousChat = async (senderId, receiverId) => {
  try {
    let data = {
      senderId: senderId,
      receiverId: receiverId,
    }

    const apiUrl = `/web/anonymous/send/like`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const readAllAnonymousUserMessage = async (userID, registerFrom) => {
  try {
    let data = {
      userId: userID,
      registerFrom: registerFrom,
    }

    const apiUrl = `/web/communications/messages/read/all`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updatePinStatus = async (userID, pinStatus) => {
  try {
    let formdata = {
      isAdminPinned: pinStatus,
      userId: userID,
    }

    const apiUrl = `/web/communications/chatMembers/pin`

    let response = await request(apiUrl, API_TYPE.PUT, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const createChatMemberAndSendMessage = async (senderId, receiverId, message) => {
  try {
    let formdata = {
      senderId: senderId,
      receiverId: receiverId,
      message: message,
    }

    const apiUrl = `/web/communications/create-chat-room`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getInvoiceData = async (filter) => {
  try {
    let formdata = filter

    if (filter?.startDate) {
      formdata['startDate'] = filter?.startDate
    }

    if (filter?.endDate) {
      formdata['endDate'] = filter?.endDate
    }

    if (filter?.paymentVia) {
      formdata['paymentVia'] = filter?.paymentVia
    }

    const apiUrl = `/web/invoice/create`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getUserReferralWithPagination = async (userID) => {
  try {
    const apiUrl = `/web/users/referral/${userID}`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getChatModeratorsAnalytics = async (
  filter,
  premiumPlanFilter,
  creditPlanFilter,
  moderatorId
) => {
  try {
    let premiumPlanIds = Object.keys(premiumPlanFilter).filter(
      (key) => premiumPlanFilter[key] === true
    )
    let creditPlanIds = Object.keys(creditPlanFilter).filter(
      (key) => creditPlanFilter[key] === true
    )

    let data = {
      startDate: filter?.startDate,
      endDate: filter?.endDate,
      premiumOrderIds: premiumPlanIds,
      creditOrderIds: creditPlanIds,
      moderatorId: moderatorId,
    }

    const apiUrl = `/web/analytics/moderator`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getChatModeratorsWiseAnalytics = async (
  filter,
  dateFormat,
  moderatorId,
  creditPlanFilter
) => {
  let {duration, startDate, endDate, view} = filter
  try {
    let creditPlanIds = Object.keys(creditPlanFilter).filter(
      (key) => creditPlanFilter[key] === true
    )

    let data = {
      duration: duration,
      view: view,
      format: dateFormat,
      creditPlanIds: creditPlanIds,
    }

    if (duration !== 'today' && duration !== 'yesterday') {
      data['startDate'] = moment(startDate).format('YYYY-MM-DD')
      data['endDate'] = moment(endDate).format('YYYY-MM-DD')
    }

    const apiUrl = `/web/analytics/moderator/${moderatorId}`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getStaticDataForModeratorDashboard = async (moderatorId) => {
  try {
    const apiUrl = `/web/analytics/moderator/dashboard?moderatorId=${moderatorId}`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const deleteAccountPermanent = async (userIDs) => {
  try {
    let formdata = {
      userIds: userIDs,
    }

    const apiUrl = `/web/users/delete/permanent`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const deleteStorePermanent = async (userIDs) => {
  try {
    let formdata = {
      userIds: userIDs,
    }

    const apiUrl = `/web/stores/delete/permanent`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getUserLiveStreaming = async (userId, page, pageSize) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    const apiUrl = `${APIURL}/users/${userId}/livestream/admin?page=${page}&pageSize=${pageSize}&userId=${userId}`

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })
    return response.data
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const deleteUserLiveStreaming = async (userId, streamingId) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    const apiUrl = `${APIURL}/users/${userId}/livestream/delete?streamingId=${streamingId}`

    let response = await axios.delete(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })
    return response.data
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getAllUserLiveStreaming = async (page, pageSize, filter) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    let apiUrl = `${APIURL}/users/1/livestream/admin/all?page=${page}&pageSize=${pageSize}`

    if (filter.search) {
      apiUrl += `&search=${filter.search}`
    }

    if (filter.streamType) {
      apiUrl += `&streamType=${filter.streamType}`
    }

    if (filter.streamStatus) {
      apiUrl += `&streamStatus=${filter.streamStatus}`
    }

    if (filter.startDate && filter.endDate) {
      apiUrl += `&startDate=${filter.startDate}&endDate=${filter.endDate}`
    }

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })
    return response.data
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getUserVideoCalls = async (userId, page, pageSize) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    const apiUrl = `${APIURL}/communications/videoCalls/users/${userId}?page=${page}&pageSize=${pageSize}`

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })
    return response.data
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const deleteUserVideoCall = async (videoCallId) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    const apiUrl = `${APIURL}/communications/videoCalls/delete?videoCallId=${videoCallId}`

    let response = await axios.delete(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })
    return response.data
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getAllVideoCalls = async (page, pageSize, filter) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    let apiUrl = `${APIURL}/communications/videoCalls/admin/all/?page=${page}&pageSize=${pageSize}`

    if (filter.startDate && filter.endDate) {
      apiUrl += `&startDate=${filter.startDate}&endDate=${filter.endDate}`
    }

    if (filter.search) {
      apiUrl += `&search=${filter.search}`
    }

    if (filter.callStatus) {
      apiUrl += `&callStatus=${filter.callStatus}`
    }

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })
    return response.data
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getAllAdsAnalyticsList = async (page, pageSize) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    const apiUrl = `${APIURL}/masters/ads-analytics?page=${page}&pageSize=${pageSize}`

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const addNewCampaignInAdsAnalytics = async (data) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    let formdata = {
      campaignName: data?.campaignName,
      platform: data?.platform,
      budgetType: data?.budgetType,
      campaignType: data?.campaignType,
      impression: data?.impression,
      campaignSource: data?.campaignSource,
      devicePlatform: data?.devicePlatform,
    }

    const apiUrl = `${APIURL}/masters/ads-analytics`

    let response = await axios.post(apiUrl, formdata, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateCampaignInAdsAnalytics = async (data) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    let formdata = {
      campaignName: data?.campaignName,
      platform: data?.platform,
      budgetType: data?.budgetType,
      campaignType: data?.campaignType,
      impression: data?.impression,
      status: data?.status,
      campaignSource: data?.campaignSource,
      devicePlatform: data?.devicePlatform,
    }

    const apiUrl = `${APIURL}/masters/ads-analytics/${data.campaignId}`

    let response = await axios.put(apiUrl, formdata, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllCampaignAdsAnalyticsList = async (page, pageSize, campaignId) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    const apiUrl = `${APIURL}/masters/campaign-ads-analytics?page=${page}&pageSize=${pageSize}&campaignId=${campaignId}`

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateCampaignAdsAnalytics = async (data) => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    let formdata = {
      budget: data?.budget,
      impression: data?.impression,
    }

    const apiUrl = `${APIURL}/masters/campaign-ads-analytics/${data.id}`

    let response = await axios.put(apiUrl, formdata, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateAllROASinAdsCampaign = async () => {
  try {
    let accessToken = localStorage.getItem('accessToken')
    const apiUrl = `${APIURL}/masters/ads-analytics/update-all-budget`

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}
